@if (display) {
  <div [class]="class">
    <mat-spinner [diameter]="diameter" />
    <br />
    <h4>{{ messageToDisplay }}</h4>
  </div>
}
